import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ExternalLink, Megaphone } from "lucide-react";

export default function Providers() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/providers").then(({ data }) => setItems(data)); }, []);
  const categories = [...new Set(items.map((p) => p.category))];

  return (
    <div className="p-8 md:p-10 max-w-[1500px]">
      <div className="mb-8">
        <div className="text-[10px] uppercase tracking-widest text-[#39FF14] mb-2">// Marketplace</div>
        <h1 className="font-display text-4xl md:text-5xl font-black tracking-tight">
          <Megaphone className="inline mr-3 mb-2 text-[#39FF14]" size={40} />
          Service providers.
        </h1>
        <p className="text-sm text-neutral-400 mt-3 max-w-2xl">
          Curated vendors that plug into a wholesaler's stack — skip tracing, dialers, TCs, lending, VAs, and more.
          <span className="text-neutral-500"> Sponsored listings marked with a green tag.</span>
        </p>
      </div>

      {categories.map((cat) => (
        <div key={cat} className="mb-8">
          <h2 className="font-display text-sm font-bold uppercase tracking-widest text-neutral-400 mb-3">{cat}</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
            {items.filter((p) => p.category === cat).map((p) => (
              <a
                key={p.id}
                data-testid={`provider-${p.id}`}
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                className="hairline bg-[#0F0F0F] p-5 hover:bg-[#141414] transition-colors group"
              >
                <div className="flex items-start justify-between gap-3 mb-3">
                  <div className="font-display text-lg font-bold">{p.name}</div>
                  {p.sponsored && (
                    <span className="hairline border-[#39FF14] text-[#39FF14] text-[9px] uppercase tracking-widest px-1.5 py-0.5">
                      Sponsored
                    </span>
                  )}
                </div>
                <p className="text-sm text-neutral-400 mb-4">{p.tagline}</p>
                <div className="flex items-center gap-1 text-[10px] uppercase tracking-widest text-neutral-500 group-hover:text-[#39FF14]">
                  Visit <ExternalLink size={11} />
                </div>
              </a>
            ))}
          </div>
        </div>
      ))}

      <div className="hairline bg-[#0F0F0F] p-6 mt-8 text-xs text-neutral-500">
        Want your service listed? Contact <span className="text-[#39FF14]">ads@kreativekpi.com</span> for sponsorship.
      </div>
    </div>
  );
}
